import {ChangeDetectionStrategy, Component, Inject, Input} from "@angular/core";
import {AviaResultRoutLeg} from "../../../../services/router/interfaces/avia-search";
import {APP_CONFIG, AppConfig} from "../../../../config/app.config";

@Component({
  selector: 'app-avia-card-badges',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './avia-card-badges.component.html',
  styleUrl: './avia-card-badges.component.scss',
  standalone: true
})
export class AviaCardBadgesComponent {
  @Input() flightType: string;
  @Input() isBestPrice: boolean;
  @Input() legs: AviaResultRoutLeg[];
  constructor(
    @Inject(APP_CONFIG) private appConfig: AppConfig,
  ) {}

  flightTypeLabel: string = '';
  isShowCabinClass: string = '';

  translations = this.appConfig.translates;
  ngOnInit(): void {
    this.setFlightType();
  }

  setFlightType() {
    switch (this.flightType) {
      case 'charter':
         this.flightTypeLabel = this.translations.aviaListing.charter;
         break;
      case 'regular':
        this.flightTypeLabel = this.translations.aviaListing.regular;
        break;
      default:
        break;
    }
  }

  get cabinClass(): string {
    const classes = new Set<string>();

    for (const leg of this.legs) {
      for (const segment of leg.segments) {
        classes.add(segment.cabinClass);
      }
    }

    const uniqueClasses = Array.from(classes);

    if (uniqueClasses.length === 1) {
      return this.formatClassName(uniqueClasses[0]);
    }

    return uniqueClasses.map(className => this.formatClassName(className)).join(' / ');
  }

  private formatClassName(className: string): string {
    if (className === 'economy') return this.translations.cabinClass.economy;
    if (className === 'business') return this.translations.cabinClass.business;
    return className; // fallback
  }
}
